<div class="box-details">
  <div *ngFor="let invoice of invoices" class="box-dsc-row row invoice-item" (click)="onEditInvoice(invoice)">
    <div [matTooltip]="invoice.dueDate | epoch" matTooltipPosition="above" class="col-5">
      <ng-container i18n>Due</ng-container>: {{ invoice.dueDate | epoch : 'DD - MMM - YYYY' }}
    </div>
    <div class="col-3 text-center">
      <span class="invoice-status">{{ invoice.status | invoiceStatus }}</span>
    </div>
    <div class="col-4 text-right">
      <app-invoice-total [invoice]="invoice"></app-invoice-total>
    </div>
  </div>
</div>
<div class="box-details" *ngIf="addable">
  <div class="box-dsc-row text-center">
    <div class="btn-group dropdown" role="group" dropdown container="body" [isDisabled]="1 | isReadonlyRole">
      <button
        type="button"
        class="btn btn-secondary-info add-invoice-btn"
        [disabled]="1 | isReadonlyRole"
        (click)="onNewInvoice(invoiceTypes.BookingInvoice)"
      >
        <span class="fal fa-usd-circle"></span><ng-container>&nbsp;</ng-container
        ><ng-container i18n>Add Invoice</ng-container>
      </button>
      <button dropdownToggle type="button" class="btn btn-secondary-info dropdown-toggle ml-0 add-invoice-btn"></button>
      <ul class="dropdown-menu" *dropdownMenu>
        <li>
          <button i18n type="button" class="dropdown-item" (click)="onNewInvoice(invoiceTypes.GeneralInvoice)">
            General Invoice
          </button>
        </li>
        <li>
          <button type="button" class="dropdown-item" (click)="onApplyInvoiceTemplate()" i18n>
            Apply Invoice Template
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
